import { defineMessages } from 'react-intl';

export const i18n: {
	externalLinkIconLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonLabel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filterByIcon: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	moreButtonTooltip: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	clearFilters: {
		id: string;
		defaultMessage: string;
	};
} = defineMessages({
	externalLinkIconLabel: {
		id: 'inline-product-filters.external-link-icon.label',
		defaultMessage: 'External Link Icon',
		description: 'Label for external link icon',
	},
	moreButtonLabel: {
		id: 'inline-product-filters.more-filters.label',
		defaultMessage: 'More',
		description: 'Label to convey that there are more filters to choose from',
	},
	filterByIcon: {
		id: 'quick-find-filters.filter-by-icon-label',
		defaultMessage: 'Filter by Icon',
		description: 'Label for filter by icon',
	},
	moreButtonTooltip: {
		id: 'inline-product-filters.more-filters.tooltip',
		defaultMessage: 'Open a full page search with more filter options for {product}',
		description: 'Tooltip for the more filters button',
	},
	clearFilters: {
		id: 'quick-find.filters.clear-filters-button-label',
		defaultMessage: 'Clear filters',
	},
});
